import React, { forwardRef } from "react";
import { useQuery } from "@apollo/client";
import { VACANCY_MANY } from "../../../schema/vacancy";
import { Vacancy } from "../../../types";

import { Loading, Error } from "../../ui/Alerts";

const VacancySelect = forwardRef((props: any, ref: any) => {
  const { loading, error, data } = useQuery(VACANCY_MANY);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <select
      {...props}
      ref={ref}
      autoComplete="type"
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
    >
      <option value=""></option>
      {data.vacancyMany.map((vacancy: Vacancy) => (
        <option key={vacancy._id} value={vacancy._id}>
          {vacancy.name}
        </option>
      ))}
    </select>
  );
});

export default VacancySelect;
